import { useLayoutEffect } from 'react';
import { WebView } from 'react-native-webview';
import { useNavigation } from '@react-navigation/native';

import { HeaderBackButton } from '../components';

export const WebContent = ({
	route: {
		params: { uri, title },
	},
}: Props) => {
	const { setOptions, goBack } = useNavigation();

	useLayoutEffect(() => {
		setOptions({
			headerTitle: title,
			headerLeft: () => <HeaderBackButton onPress={goBack} />,
		});
	}, [title, goBack, setOptions]);

	return <WebView source={{ uri }} />;
};

interface Props {
	route: {
		params: WebContentParams;
	};
}

export type WebContentParams = {
	uri: string;
	title: string;
};
